import { handleActions } from 'redux-actions';

const initialState = {
  id: null,
  name: null,
  src: null,
  show: false,
  messages: [],
  isLoop: false,
  targetDisplaySize: null,
  resolution: null,
  rotation: null,
};

export default handleActions(
  {
    SET_DISPLAY: (state, action) => {
      const data = action.payload;

      return {
        ...state,
        ...data,
        show: data.show || false,
      };
    },
  },
  // Initial State
  initialState,
);
